const DEFAULT_OG_IMAGE_PATH = "/icons/icon-192x192.png";

export const OG_IMAGE_WIDTH = 192;
export const OG_IMAGE_HEIGHT = 192;
export const OG_IMAGE_MIME = "image/png";

function toHttpsAbsoluteUrl(base) {
  const s = String(base || "").trim();
  if (!s) return "";
  if (s.startsWith("https://")) return s.replace(/\/$/, "");
  if (s.startsWith("http://"))
    return s.replace(/^http:\/\//i, "https://").replace(/\/$/, "");
  if (s.startsWith("//")) return `https:${s}`.replace(/\/$/, "");
  return `https://${s.replace(/\/$/, "")}`;
}

/**
 * @param {string} [siteOrigin] — Util.getOrigin('www')
 * @returns {string} https absolute URL for og:image
 */
export function getOgImageUrl(siteOrigin) {
  const fromEnv = process.env.NEXT_PUBLIC_OG_IMAGE_URL;
  if (fromEnv && String(fromEnv).trim()) {
    return toHttpsAbsoluteUrl(fromEnv);
  }

  if (!process.env.NEXT_PUBLIC_DEV) {
    const cdn = process.env.NEXT_PUBLIC_cdn;
    if (cdn) {
      return `${toHttpsAbsoluteUrl(cdn)}/public${DEFAULT_OG_IMAGE_PATH}`;
    }
  }

  const origin = toHttpsAbsoluteUrl(siteOrigin);
  return origin ? `${origin}${DEFAULT_OG_IMAGE_PATH}` : DEFAULT_OG_IMAGE_PATH;
}
